export default __webpack_public_path__ + "static/home-blog-f39ddb9a1c4704976ad4563f0763447c.webp";